import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Container, Row } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../common/GenericBrowsePageResizeHelper";
import Loader from "../common/Loader";
import GenericTeletabberGallery from "../gallery/GenericTeletabberGallery";
import TitleNavbar from "../navbars/TitleNavbar";
import ToolbarSelector from "../navbars/ToolbarSelector";

interface IPodiumSpeakerParams {
  tenant: string;
  meetingId: string;
  speakerId: string;
}

const SpeakerBrowsePage: React.FC<
  RouteComponentProps<IPodiumSpeakerParams>
> = ({ history, match, location }) => {
  const rootStore = useContext(RootStoreContext);
  const { currentBrowsePageContent, resetBrowsePage } = rootStore.commonStore;
  const { errorUrl } = rootStore.tenantStore;
  const { loadSpeakerContent } = rootStore.podiumStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
  const [galleryStartingPage, setGalleryStartingPage] = useState(0);

  useEffect(() => {
    let intMeetingId = parseInt(match.params.meetingId);
    let intSpeakerId = parseInt(match.params.speakerId);

    if (intMeetingId && intSpeakerId) {
      const urlParams = new URLSearchParams(location.search);
      //gallery page
      const page = urlParams.get("pag") ?? "";
      let intPage = parseInt(page);
      setGalleryStartingPage(intPage);

      loadSpeakerContent(intMeetingId, intSpeakerId)
        .then()
        .catch(() => history.push(errorUrl));
    } else history.push(errorUrl);

    return () => {
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [
    location.search,
    match.params.meetingId,
    match.params.speakerId,
    errorUrl,
    history,
    loadSpeakerContent,
    resetBrowsePage,
    destroyZwibblerContext,
  ]);

  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <Container fluid>
        <GenericBrowsePageResizeHelper />
        <Row>
          <TitleNavbar title={currentBrowsePageContent.title.document} />
        </Row>
        <Row>
          <ToolbarSelector
            items={currentBrowsePageContent.items}
            isSidebarOpen={false}
            stickyButton="share"
          />
        </Row>
        <Row>
          <GenericTeletabberGallery
            items={currentBrowsePageContent.items}
            startingPage={galleryStartingPage}
          />
        </Row>
      </Container>
    </>
  );
};

export default observer(SpeakerBrowsePage);
